import {IUserJson} from "../../../../nodeserver/structs/database";
import JSX from "../helpers/react.js";

export default function UserColumn({user}: {user: IUserJson}){
    return (
        <div className="anime-column user-column" data-id={user.id}>
            <a className="image-block bordered" title={user.nickname} href={`/users/id${user.id}`}>
                <img src={user.avatars.full} loading="lazy" alt="" />
            </a>
            <div>
                <a href={`/users/id${user.id}`} className="friend-name">{user.nickname}</a>
            </div>
        </div>
    );
}
